<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 11:40:48 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-15 14:02:41 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/meeting-card/src/izt-meeting-card.vue
 * @Description  : 会议/活动卡片
-->
<style lang="scss" scoped>
.izt-meeting-card-container {
  background: #FFFFFF;
  box-shadow: 0px 5px 6px 0px rgba(0,0,0,0.1);
  border-radius: 24px;
  min-height: 0;
  overflow: hidden;
  color: rgba($color: #000000, $alpha: 0.65);
  .head-area-container {
    .meeting-date {
      padding: 24px;
      padding-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .date {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 24px;
        gap: 4px;
      }
    }
    .meeting-name {
      padding: 16px 24px;
      background-color: var(--izt-theme-color);
      color: var(--izt-theme-text-color-65);
      font-weight: bold;
      font-size: 28px;
    }
  }
  .main-container {
    padding: 24px;
    .position {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 24px;
      line-height: 1;
    }
    .rec-short {
      margin-top: 16px;
    }
  }
}
</style>

<template>
  <div class="izt-meeting-card-container" @click.stop="emit('click', {data, type: 'meeting'})">
    <div class="head-area-container">
      <div class="meeting-date">
        <div class="date">
          <izt-icon class-name="icon-a-68show_shijianlishiji"></izt-icon>
          <span>{{ $timeJudge(data.date) }}</span>
        </div>
        <div class="real-label type">{{ [$t('card.会议活动'), $t('card.会议'), $t('card.活动')][(+type) || 0] }}</div>
      </div>
      <div class="meeting-name">{{data.name}}</div>
    </div>
    <div class="main-container">
      <div class="position">
        <izt-icon class-name="icon-a-88show_didiandingwei"></izt-icon>
        <span>{{data.location}}</span>
      </div>
      <div class="rec-short">
        <izt-ai-rec-short :text="data.recommend_reason"/>
      </div>
    </div>
  </div>
</template>

<script setup name="izt-meeting-card">
  defineOptions({ name: 'izt-meeting-card' })

  defineProps({
    data: { type: Object, default: () => ({}) },
    type: { type: [String, Number], default: '0' },
  })
  const emit = defineEmits(['click'])
</script>